import { FC } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../Store'
import { boreholeFigureStyle } from './BoreholeFigure.style'
import { NearestBoreholeObject } from 'src/dataSources/geo/NearestBoreHoles'

/**
 * BoreholeFigureProps contains properties for the component.
 */
export interface BoreholeFigureProps {
  selectedBorehole: NearestBoreholeObject | undefined
}

/**
 * BoreholeFigure displays figures and legend for boreholes.
 * @param props Properties for component.
 * @returns JSX component.
 */
export const BoreholeFigure: FC<BoreholeFigureProps> = (props: BoreholeFigureProps) => {
  const classes = boreholeFigureStyle()
  const image = useSelector((state: RootState) => state.boreholeInfo.boreholeSvg)

  return (
    <>
      <div className={classes.root} dangerouslySetInnerHTML={{ __html: image }} />
    </>
  )
}
